import { css } from '@emotion/react';
import { theme } from 'styles/theme';

export type RadioOption = {
	label: string;
	value: string | number;
};

export const Radios = ({
	options,
	value,
	onChange,
}: {
	options: RadioOption[];
	value: string | number;
	onChange: (value: string | number) => void;
}) => {
	return (
		<div
			css={css`
				display: flex;
			`}
		>
			{options.map((item, key) => {
				return (
					<div
						css={css`
							display: flex;
							margin-right: 24px;

							&:hover {
								cursor: pointer;
							}
						`}
						key={key}
						onClick={() => {
							onChange(item.value);
						}}
					>
						<div
							css={css`
								border: 1px solid #d4d5de;
								width: 20px;
								height: 20px;
								border-radius: 20px;
								margin-right: 12px;
								position: relative;

								${item.value === value &&
								css`
									&:before {
										content: '';
										position: absolute;
										width: 12px;
										height: 12px;
										background: ${theme.color.primary['400']};
										top: 3px;
										left: 3px;
										border-radius: 12px;
									}
								`}
							`}
						></div>
						{item.label}
					</div>
				);
			})}
		</div>
	);
};
